import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component like
 * Histogram, Calendar and Hero
 */

/**
 * This method return a Request object after delete unnecessary parameter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRequestHistogram = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = [
    'uiDatesYearsAdjustmentPatch',
    'dateRange',
    'siteEdition',
    'page',
    'airlineIataCode',
    'airport',
    'airlineCode',
    'returnDateRange',
    'dateAfterReurnDate',
    'dateBeforeReurnDate',
    'ignoreCurrencyCode'
  ];

  // params to delete when has empty value
  const paramsEmpty = [
    'origins',
    'destinations',
    'outputCurrencies',
    'markets',
    'currencyPricingSettings',
    'travelClasses'
  ];

  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);

  return cleanRequest;
};

export default transformRequestHistogram;
